// extracted by mini-css-extract-plugin
export default {"login-text-field-label":"form-elements_login-text-field-label__Jth8k","login-text-field-input":"form-elements_login-text-field-input__ahbfj"};